import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { HelpCircle as HelpCircleIcon } from 'react-feather'
import { isEmpty } from 'lodash'
import qs from 'query-string'
import { Button, Container } from '@material-ui/core'

import { ContentHeader, DriveTour, Page } from 'components'
import { Form } from './components'

import useIncidentManegement from 'hooks/useIncidentManegement'
import useConvertToFile from 'hooks/useConvertToFile'

import constants from 'constants/index'
import helpers from 'helpers'

const IncidentManagementCreate = () => {
  const [openTour, setOpenTour] = useState(false)
  const location = useLocation()

  const query = qs.parse(location.search)

  const { incident, setIncident, activeStep } = useIncidentManegement()
  const { fileList, loading } = useConvertToFile(incident?.detectionAttachments)

  const currentStep = helpers.incidents.incidentManegementSteps(incident, true)[
    activeStep
  ]

  const handleOpenTour = () => {
    const where = 'Incidentes'
    const title = 'Tour'

    const params = {
      action: 'tour-editar-incidente',
    }

    helpers.mixpanel.track(where, title, params)
    setOpenTour(true)
  }

  useEffect(() => {
    if (!isEmpty(incident) && !loading)
      setIncident((prevIncident) => ({
        ...prevIncident,
        detectionAttachmentsList: fileList,
      }))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fileList, loading])

  return (
    <Page title="Novo incidente">
      <Container maxWidth={false}>
        <ContentHeader title="Novo Incidente">
          <Button
            variant="contained"
            color="primary"
            startIcon={<HelpCircleIcon size={20} />}
            onClick={handleOpenTour}
            id={constants.incidents.INCIDENT_MAIN_DRIVER_STEP_0}
            fullWidth
          >
            Tutorial
          </Button>
        </ContentHeader>

        <Form type="create" query={query} />
      </Container>
      <DriveTour
        stepsMatrix={helpers.incidents.driverJs.chooseStepsObject(currentStep)}
        open={openTour}
        setOpen={setOpenTour}
      />
    </Page>
  )
}

export default IncidentManagementCreate
